export const AvatarHeadStyle1 = ({ id, colors }) => {
  return (
    <g id="Estilo1_6_">
      <linearGradient
        id={`${id}-SVGID_145_`}
        gradientUnits="userSpaceOnUse"
        x1="62.3591"
        y1="-297.3179"
        x2="21.508"
        y2="-355.1477"
        gradientTransform="matrix(1 0 0 1 0 380)"
      >
        <stop
          offset="0"
          style={{ stopColor: colors[0] }}
          data-color={colors[0]}
        />
        <stop offset=".175" style={{ stopColor: colors[1] }} />
        <stop offset=".506" style={{ stopColor: colors[2] }} />
        <stop offset=".568" style={{ stopColor: colors[3] }} />
        <stop offset=".784" style={{ stopColor: colors[4] }} />
        <stop offset="1" style={{ stopColor: colors[5] }} />
      </linearGradient>
      <path
        style={{ display: 'inline', fill: `url(#${id}-SVGID_145_)` }}
        d="M58.7,65.7c2.2,4.2,1.3,9.1-2.1,10.8s-7.8-0.3-10.1-4.5 c-2.2-4.2-1.3-9.1,2.1-10.8C52,59.5,56.5,61.5,58.7,65.7z"
      />

      <linearGradient
        id={`${id}-SVGID_146_`}
        gradientUnits="userSpaceOnUse"
        x1="82.3722"
        y1="-291.0465"
        x2="161.8148"
        y2="-389.2361"
        gradientTransform="matrix(1 0 0 1 0 380)"
      >
        <stop offset="0" style={{ stopColor: colors[0] }} />
        <stop offset=".175" style={{ stopColor: colors[1] }} />
        <stop offset=".506" style={{ stopColor: colors[2] }} />
        <stop offset=".568" style={{ stopColor: colors[3] }} />
        <stop offset=".784" style={{ stopColor: colors[4] }} />
        <stop offset="1" style={{ stopColor: colors[5] }} />
      </linearGradient>
      <path
        style={{ display: 'inline', fill: `url(#${id}-SVGID_146_)` }}
        d="M92.5,65.7c-2.2,4.2-1.3,9.1,2.1,10.8s7.8-0.3,10.1-4.5s1.3-9.1-2.1-10.8 C99.3,59.5,94.8,61.5,92.5,65.7z"
      />

      <linearGradient
        id={`${id}-Multiply_53_`}
        gradientUnits="userSpaceOnUse"
        x1="91.5617"
        y1="-306.6266"
        x2="108.8276"
        y2="-317.0703"
        gradientTransform="matrix(1 0 0 1 0 380)"
      >
        <stop offset="0" style={{ stopColor: '#FFE7D8' }} />
        <stop offset="0.2873" style={{ stopColor: '#FABDC9' }} />
        <stop offset="0.5941" style={{ stopColor: '#F597BB' }} />
        <stop offset="0.8407" style={{ stopColor: '#F280B3' }} />
        <stop offset="0.9944" style={{ stopColor: '#F177B0' }} />
      </linearGradient>

      <path
        id="Multiply_1_"
        style={{
          display: 'inline',
          opacity: '0.6',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: `url(#${id}-Multiply_53_)`,
          enableBackground: 'new'
        }}
        d=" M103.6,67.1c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4c0-1.2-0.2-1.9-0.5-2.3c-0.2-0.2-0.4-0.4-0.7-0.4c-0.3,0-0.6,0.1-1,0.3 c-1,0.6-2,1.8-2.5,3.2c-0.3,0.6-0.5,1.3-0.6,1.8c0.6-0.4,1.2-0.6,1.7-0.5c0.3,0,0.6,0.1,0.8,0.3c0.2,0.2,0.4,0.4,0.5,0.7 c0.2,0.5,0,1.3-0.5,2.1c-0.1,0.2-0.3,0.2-0.5,0.1c-0.2-0.1-0.2-0.4-0.1-0.5c0.4-0.6,0.5-1.1,0.4-1.4c0-0.1-0.1-0.3-0.2-0.3 c-0.1-0.1-0.3-0.1-0.4-0.2c-0.5-0.1-1.1,0.2-1.6,0.7c-0.1,0.1-0.3,0.2-0.4,0.3c-0.3,0.1-0.5-0.1-0.5-0.4l0,0c0-0.1,0-0.3,0-0.4 c0.1-0.6,0.4-1.5,0.8-2.5c0.6-1.5,1.7-2.9,2.8-3.5c0.5-0.3,0.9-0.4,1.4-0.4c0.5,0,0.9,0.2,1.2,0.7 C103.3,64.8,103.6,65.7,103.6,67.1z"
      />

      <linearGradient
        id={`${id}-Multiply_54_`}
        gradientUnits="userSpaceOnUse"
        x1="46.0227"
        y1="-319.1104"
        x2="57.5401"
        y2="-304.3446"
        gradientTransform="matrix(1 0 0 1 0 380)"
      >
        <stop offset="0" style={{ stopColor: '#FFE7D8' }} />
        <stop offset="0.2873" style={{ stopColor: '#FABDC9' }} />
        <stop offset="0.5941" style={{ stopColor: '#F597BB' }} />
        <stop offset="0.8407" style={{ stopColor: '#F280B3' }} />
        <stop offset="0.9944" style={{ stopColor: '#F177B0' }} />
      </linearGradient>

      <path
        id="Multiply"
        style={{
          display: 'inline',
          opacity: '0.6',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: `url(#${id}-Multiply_54_)`,
          enableBackground: 'new'
        }}
        d=" M48,67.1c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4c0-1.2,0.2-1.9,0.5-2.3c0.2-0.2,0.4-0.4,0.7-0.4c0.3,0,0.6,0.1,1,0.3 c1,0.6,2,1.8,2.5,3.2c0.3,0.6,0.5,1.3,0.6,1.8c-0.6-0.4-1.2-0.6-1.7-0.5c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.4,0.4-0.5,0.7 c-0.2,0.5,0,1.3,0.5,2.1c0.1,0.2,0.3,0.2,0.5,0.1s0.2-0.4,0.1-0.5c-0.4-0.6-0.5-1.1-0.4-1.4c0-0.1,0.1-0.3,0.2-0.3 c0.1-0.1,0.3-0.1,0.4-0.2c0.5-0.1,1.1,0.2,1.6,0.7c0.1,0.1,0.3,0.2,0.4,0.3c0.3,0.1,0.5-0.1,0.5-0.4l0,0c0-0.1,0-0.3,0-0.4 c-0.1-0.6-0.4-1.5-0.8-2.5c-0.6-1.5-1.7-2.9-2.8-3.5c-0.5-0.3-0.9-0.4-1.4-0.4c-0.5,0-0.9,0.2-1.2,0.7C48.3,64.8,48,65.7,48,67.1z "
      />

      <linearGradient
        id={`${id}-Multiply_55_`}
        gradientUnits="userSpaceOnUse"
        x1="75.675"
        y1="-283.7682"
        x2="75.675"
        y2="-297.2288"
        gradientTransform="matrix(1 0 0 1 0 380)"
      >
        <stop offset="5.586999e-03" style={{ stopColor: '#CE77F1' }} />
        <stop offset="0.1593" style={{ stopColor: '#D280EF' }} />
        <stop offset="0.4059" style={{ stopColor: '#DC97EA' }} />
        <stop offset="0.7127" style={{ stopColor: '#EDBDE1' }} />
        <stop offset="1" style={{ stopColor: '#FFE7D8' }} />
      </linearGradient>
      <path
        id="Multiply_2_"
        style={{
          display: 'inline',
          opacity: '0.6',
          fill: `url(#${id}-Multiply_55_)`,
          enableBackground: 'new'
        }}
        d="M75.5,88.4 c-5.4,0-12.1-4-16.3-7c0.6,0.8,1.3,1.6,2.1,2.3c3.4,2.9,9.5,7.5,14.3,7.5c4.8,0,10.8-4.5,14.3-7.5c0.8-0.7,1.6-1.6,2.2-2.5 C87.9,84.2,81,88.4,75.5,88.4z"
      />

      <linearGradient
        id={`${id}-SVGID_147_`}
        gradientUnits="userSpaceOnUse"
        x1="76"
        y1="388.75"
        x2="76"
        y2="445.9564"
        gradientTransform="matrix(1 0 0 -1 0 480)"
      >
        <stop offset="0" style={{ stopColor: colors[0] }} />
        <stop offset=".175" style={{ stopColor: colors[1] }} />
        <stop offset=".506" style={{ stopColor: colors[2] }} />
        <stop offset=".568" style={{ stopColor: colors[3] }} />
        <stop offset=".784" style={{ stopColor: colors[4] }} />
        <stop offset="1" style={{ stopColor: colors[5] }} />
      </linearGradient>
      <path
        style={{ display: 'inline', fill: `url(#${id}-SVGID_147_)` }}
        d="M97.5,55.5c0-12.4-9.1-21-21.5-21s-21.5,8.6-21.5,21c0,3,0,5,0.7,10 c0,0.3,0.1,0.7,0.2,1l0,2.4c0,12.3,9.1,22.3,20.4,22.3s20.4-10,20.4-22.3v-1.3c0-0.2,0.1-0.5,0.1-0.7 C96.5,61.5,97.5,59.1,97.5,55.5z"
      />

      <linearGradient
        id={`${id}-Multiply_56_`}
        gradientUnits="userSpaceOnUse"
        x1="75.67"
        y1="384.9574"
        x2="75.67"
        y2="397.4331"
        gradientTransform="matrix(1 0 0 -1 0 480)"
      >
        <stop offset="5.586999e-03" style={{ stopColor: '#CE77F1' }} />
        <stop offset="0.1593" style={{ stopColor: '#D280EF' }} />
        <stop offset="0.4059" style={{ stopColor: '#DC97EA' }} />
        <stop offset="0.7127" style={{ stopColor: '#EDBDE1' }} />
        <stop offset="1" style={{ stopColor: '#FFE7D8' }} />
      </linearGradient>
      <path
        id="Multiply_7_"
        style={{
          display: 'inline',
          opacity: '0.6',
          fill: `url(#${id}-Multiply_56_)`,
          enableBackground: 'new'
        }}
        d="M75.7,87.9 c-7.3,0-13.8-3.3-18-8.5c3.4,7,10.2,11.8,18,11.8s14.6-4.8,18-11.8C89.5,84.6,83,87.9,75.7,87.9z"
      />
    </g>
  )
}
